import React, { Component } from 'react';

import axios from 'axios';

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image.js';

import Projection from 'ol/proj/Projection.js';
import WMTS from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';

import { transformExtent } from 'ol/proj.js';

import ImageWMS from 'ol/source/ImageWMS.js';

import WMSCapabilities from 'ol/format/WMSCapabilities.js';

import { register } from 'ol/proj/proj4.js';
import proj4 from 'proj4';

import config from '../../config';

// import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
// import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';

// TODO: Switch WMS to WMTS for preview
class PreviewMap extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      // TODO: Fix this before prod
      geoserverUrl: `${config.geoserverUrl}/geoserver/${this.props.workspace}/wms?timestamp=${Date.now()}`, // `${config.geoserverUrl}${this.props.workspace}/wms`,
      map: null,
      layer: null
    }
  }

  componentDidMount() {

    proj4.defs("EPSG:3067","+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    register(proj4);

    const projection = new Projection({
      code: 'EPSG:3067',
      extent: [-3669433.90, 4601644.86, 648181.26, 9364104.12]
    });

    let map = new Map({
      target: this.refs.previewMapContainer,
      layers: [
        new TileLayer({
          source: new WMTS({
            attributions: '© CGI, <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            url: config.basemapUrl,
            layer: 'basemaps:rk',
            matrixSet: "ETRS-TM35FIN",
            format: "image/png8",
            projection: projection,
            tileGrid: new WMTSTileGrid({
              origin: [-2097152.0, 9437184.0],
              resolutions: [2048.0, 1024.0, 512.0, 256.0, 128.0, 64.0, 32.0, 16.0, 8.0, 4.0, 2.0, 1.0, 0.5],
              matrixIds: ["ETRS-TM35FIN:2", "ETRS-TM35FIN:3", "ETRS-TM35FIN:4",
    						"ETRS-TM35FIN:5", "ETRS-TM35FIN:6", "ETRS-TM35FIN:7", "ETRS-TM35FIN:8", "ETRS-TM35FIN:9", "ETRS-TM35FIN:10",
    						"ETRS-TM35FIN:11", "ETRS-TM35FIN:12", "ETRS-TM35FIN:13", "ETRS-TM35FIN:14"
              ]
            }),
            style: 'default',
            wrapX: true
          })
        })
      ],
      view: new View({
        center: [483849.001900, 7048931.131329],
        zoom: 4,
        minZoom: 3,
        maxZoom: 18,
        projection: projection,
        extent: [-2097152.0, 5242880.0, 3145728.0, 9437184.0],
        enableRotation: false,
      })
    });

    // save map and layer references to local state
    this.setState({
      map: map,
    }, () => this.addPreviewLayer());

  }

  addPreviewLayer() {

    const layer = new ImageLayer({
      source: new ImageWMS({
        url: this.props.apikey ? this.state.geoserverUrl + `&apikey=${this.props.apikey}` : this.state.geoserverUrl,
        params: { 'LAYERS': `${this.props.workspace}:${this.props.layer}${this.props.isPreview ? '_preview' : ''}` },
        serverType: 'geoserver',
        // crossOrigin: 'anonymous',
        ratio: 1,
      })
    })

    this.state.map.addLayer(layer);

    this.setState({ layer: layer }, () => this.centerOnPreviewLayer());
  }

  centerOnPreviewLayer() {
    // NOTE: Requires CORS. In Production we will user Kong plugin
    // in dev there is no solution for this (yet)
    const parser = new WMSCapabilities();
    // Parse WMS Capabilities to retrieve layer extent
    axios.get(`${this.state.geoserverUrl}${this.props.apikey ? "&apikey=" + this.props.apikey : ""}&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities`, { responseType: 'text', withCredentials: false })
    .then((response) => {
       return response.data;
    })
    .then((text) => {
        const result = parser.read(text);
        const extent = result.Capability.Layer.Layer.find(l => l.Name === `${this.props.layer}${this.props.isPreview && "_preview"}`).EX_GeographicBoundingBox;
        const extent_3067 = transformExtent(extent, 'EPSG:4326', 'EPSG:3067');
        const prjExtent = this.state.map.getView().getProjection().getExtent();

        // Zoom to data if it is inside projection extent
        if (extent_3067[0] > prjExtent[0] ||
            extent_3067[1] > prjExtent[1] ||
            extent_3067[2] < prjExtent[2] ||
            extent_3067[3] < prjExtent[3]) {
          this.state.map.getView().fit(extent_3067);
        }
    })
    .catch((err) => {
      console.log(err);
    });

  }

  render() {
    return(
      <div style={{ width: "100%", height: 480 }} ref="previewMapContainer"> </div>
    )
  }
}

export default PreviewMap;



// WEBPACK FOOTER //
// ./src/containers/main/PreviewMap.js